"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "altopascio": {
    "8bca394f": [{
      "hkey": "51322f22",
      "slug": "spianate-checi-fabbri",
      "name": "Spianate-Checi-Fabbri",
      "primary": true,
      "skipSearch": false
    }],
    "spianate": [{
      "hkey": "51322f22",
      "slug": "spianate-checi-fabbri",
      "name": "Spianate-Checi-Fabbri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;